import { useEffect, ReactNode } from "react";

import { show } from "@intercom/messenger-js-sdk";
import { Button, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { clearAllUserData } from "../../../../common/services/auth/Auth.service";

enum NOTIFICATION_TYPES {
  ERROR = "error",
  SUCCESS = "success",
}

interface Props {
  buttonCopy: ReactNode;
  description: ReactNode;
  heading: ReactNode;
  type?: "error" | "success";
}

const EAgriImportNotification = ({
  buttonCopy,
  description,
  heading,
  type = NOTIFICATION_TYPES.SUCCESS,
}: Props) => {
  const classes = useStyles();

  useEffect(() => {
    clearAllUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = () => {
    show();
  };

  return (
    <div>
      <Typography classes={{ root: classes.heading }} variant="h5">
        {heading}
      </Typography>
      <Typography component="p" variant="subtitle1">
        {description}
      </Typography>
      {type === NOTIFICATION_TYPES.ERROR && (
        <Button
          className={classes.button}
          color="primary"
          onClick={handleClick}
          variant="contained"
        >
          {buttonCopy}
        </Button>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  heading: {
    fontWeight: 500,
    marginBottom: 8,
  },
  button: {
    width: "100%",
    marginTop: 36,
  },
});

export { EAgriImportNotification };
